import { Bin } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconBin12Line = createIcon(Bin, 12, "Line");
export const IconBin16Line = createIcon(Bin, 16, "Line");
export const IconBin20Line = createIcon(Bin, 20, "Line");
export const IconBin24Line = createIcon(Bin, 24, "Line");
export const IconBin32Line = createIcon(Bin, 32, "Line");
export const IconBin48Line = createIcon(Bin, 48, "Line");
export const IconBin64Line = createIcon(Bin, 64, "Line");
